import { css as _css } from "@emotion/react";
import _pt from "prop-types";
import { Heading } from '@datacamp/waffles-text';
import tokens from '@datacamp/waffles-tokens';
import React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";

var Header = function Header(_ref) {
  var children = _ref.children;
  return ___EmotionJSX("header", {
    css: /*#__PURE__*/_css({
      flex: 'none',
      paddingBottom: tokens.spacing.medium,
      paddingLeft: tokens.spacing.large,
      paddingRight: tokens.spacing.large,
      paddingTop: tokens.spacing.large
    }, process.env.NODE_ENV === "production" ? "" : ";label:Header;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9zaGFyZWQvSGVhZGVyLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFhSSIsImZpbGUiOiIuLi8uLi9zcmMvc2hhcmVkL0hlYWRlci50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBIZWFkaW5nIH0gZnJvbSAnQGRhdGFjYW1wL3dhZmZsZXMtdGV4dCc7XG5pbXBvcnQgdG9rZW5zIGZyb20gJ0BkYXRhY2FtcC93YWZmbGVzLXRva2Vucyc7XG5pbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuXG5leHBvcnQgaW50ZXJmYWNlIEhlYWRlclByb3BzIHtcbiAgLyoqXG4gICAqIFRoZSB0aXRsZSBvZiB0aGUgRGlhbG9nLlxuICAgKi9cbiAgY2hpbGRyZW46IFJlYWN0LlJlYWN0Tm9kZTtcbn1cblxuY29uc3QgSGVhZGVyID0gKHsgY2hpbGRyZW4gfTogSGVhZGVyUHJvcHMpOiBKU1guRWxlbWVudCA9PiAoXG4gIDxoZWFkZXJcbiAgICBjc3M9e3tcbiAgICAgIGZsZXg6ICdub25lJyxcbiAgICAgIHBhZGRpbmdCb3R0b206IHRva2Vucy5zcGFjaW5nLm1lZGl1bSxcbiAgICAgIHBhZGRpbmdMZWZ0OiB0b2tlbnMuc3BhY2luZy5sYXJnZSxcbiAgICAgIHBhZGRpbmdSaWdodDogdG9rZW5zLnNwYWNpbmcubGFyZ2UsXG4gICAgICBwYWRkaW5nVG9wOiB0b2tlbnMuc3BhY2luZy5sYXJnZSxcbiAgICB9fVxuICA+XG4gICAgPEhlYWRpbmcgYXM9XCJoMlwiIHNpemU9ezY1MH0+XG4gICAgICB7Y2hpbGRyZW59XG4gICAgPC9IZWFkaW5nPlxuICA8L2hlYWRlcj5cbik7XG5cbmV4cG9ydCBkZWZhdWx0IEhlYWRlcjtcbiJdfQ== */")
  }, ___EmotionJSX(Heading, {
    as: "h2",
    size: 650
  }, children));
};

Header.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _pt.node.isRequired
} : {};
export default Header;